import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { EyeOff } from '../shapes';


const EyeOffSvg = (props) => (
  <g>
    <IconBounds />
    <EyeOff {...props} />
  </g>
);

EyeOffSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

EyeOffSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default EyeOffSvg;
